import type { FunctionComponent } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import { months } from '@/domains/core/localization/months';
import {
  reviewsOneDay,
  reviewsOneWeek,
  reviewsOtherDay,
  reviewsOtherWeek,
  reviewsToday,
} from '@/domains/productDiscovery/ArticleReviews/translations';

import styles from './reviewdatetag.module.scss';

export const getNumberOfDays = (date: string) => {
  const dateFormat = new Date(date);
  const oneDay = 1000 * 60 * 60 * 24;
  const diffInTime = new Date().getTime() - dateFormat.getTime();
  const diffInDays = Math.round(diffInTime / oneDay);

  return diffInDays;
};

export const getFormattedDate = (createdAt: string) =>
  `${new Date(createdAt).getDate()} ${
    months[new Date(createdAt).getMonth()]
  } ${new Date(createdAt).getFullYear()}`;

interface Props {
  createdAt: string;
  textColor?: string;
}

export const ReviewDateTag: FunctionComponent<Props> = ({
  createdAt,
  textColor = '#505971',
}) => {
  const nbDaysReview = getNumberOfDays(createdAt);
  if (nbDaysReview === 0)
    return <div className={styles.tagContainer}>{reviewsToday}</div>;
  if (nbDaysReview <= 7) {
    return (
      <div className={styles.tagContainer}>
        {nbDaysReview < 2
          ? reviewsOneDay.format({ total: nbDaysReview })
          : reviewsOtherDay.format({ total: nbDaysReview })}
      </div>
    );
  }
  if (nbDaysReview > 7 && nbDaysReview <= 28) {
    const weeks = Math.floor(nbDaysReview / 7);
    return (
      <Text type="small" color={textColor} className={styles.date}>
        {weeks === 1
          ? reviewsOneWeek.format({ total: 1 })
          : reviewsOtherWeek.format({
              total: weeks,
            })}
      </Text>
    );
  }
  return (
    <Text type="small" color={textColor} className={styles.date}>
      {getFormattedDate(createdAt)}
    </Text>
  );
};
